import './module';
import './deal/services';
import './directives.js';
import './deal/controllers';
import './inventory/items/services';
import './inventory/items/controllers';
import './inventory/sources/services';
import './inventory/sources/controllers';
import './import/index.controller.js';
import './import/services.js';
import './inventory/cluster/controllers';
import './inventory/cluster/services';

